import ReactApexChart from 'react-apexcharts';

import styled from 'styled-components';

import { useGetGroupInsights } from 'hooks/queries/dashboard';
import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreLoading from 'shared/CoreLoading';
import { ReportSectionCard, ReportTopHeader } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

const MiniDonutChart = () => {
	const options = {
		chart: {
			type: 'donut' as const,
			height: 24,
			width: 24,
			toolbar: {
				show: false, // 툴바 숨김
			},
		},
		plotOptions: {
			pie: {
				donut: {
					size: '35%', // 도넛 두께 조정
				},
			},
		},
		colors: ['#FF4560', '#DEE2E6'], // 색상: 빨간색, 회색
		dataLabels: {
			enabled: false, // 데이터 레이블 숨김
		},
		tooltip: {
			enabled: false, // 툴팁 비활성화
		},
		legend: {
			show: false, // 범례 숨김
		},
		stroke: {
			show: false, // 선 제거
		},
	};

	const series = [40, 60];

	return (
		<div style={{ width: '40px', height: '40px' }}>
			<ReactApexChart options={options} series={series} type="donut" height="60" />
		</div>
	);
};

function CreatorCategoryStats() {
	const [groupId] = useGetSearchParams(['groupId']);

	const { data: groupInsights, isLoading: groupInsightsLoading } =
		useGetGroupInsights(groupId);

	const creatorCategoryDistribution = groupInsights?.creatorCategoryDistribution;

	if (groupInsightsLoading) {
		return (
			<ReportSectionCard>
				<ReportTopHeader>크리에이터 카테고리 분포</ReportTopHeader>
				<Grid flex="center" direction="column" _height="100%">
					<CoreLoading color_type="gray" />
				</Grid>
			</ReportSectionCard>
		);
	}

	return (
		<>
			<ReportSectionCard>
				<ReportTopHeader>크리에이터 카테고리 분포</ReportTopHeader>
				<Grid flex="start" direction="column" _gap="32px">
					{creatorCategoryDistribution
						?.sort((a, b) => b?.percentage - a?.percentage)
						?.slice(0, 4)
						?.map((item, index) => (
							<Grid key={index} flex="between">
								{index === 0 && (
									<Grid flex="between">
										<HighlightText typo="h2">{item.category}</HighlightText>
										<Grid flex="start" _width="110px">
											<HighlightText typo="h2">{item.percentage}%</HighlightText>
											<MiniDonutChart />
										</Grid>
									</Grid>
								)}
								{index === 1 && (
									<>
										<Text typo="p_bold">{item.category}</Text>
										<Text typo="p_bold" _width="73px">
											{item.percentage}%
										</Text>
									</>
								)}
								{index !== 0 && index !== 1 && (
									<>
										<Text typo="p">{item.category}</Text>
										<Text typo="p" _width="73px">
											{item.percentage}%
										</Text>
									</>
								)}
							</Grid>
						))}
				</Grid>
			</ReportSectionCard>
		</>
	);
}
const { Grid, Text } = style;

const HighlightText = styled(Text)`
	color: ${({ theme }) => theme.colors.uplus.primary50_key};
`;

const RelativeGrid = styled(Grid)`
	position: relative;
`;
const AbsoluteChart = styled.div`
	position: absolute;
	top: 0;
`;

export default CreatorCategoryStats;
